import Marionette from 'backbone.marionette';
import Navigator from 'app';
import MembersItemview from './members_itemview';
export default Marionette.CollectionView.extend({
  childView: MembersItemview,
  onRender: function () {
    Navigator.addTips(); //to account for filtering
  }
});